<div
  [hidden]="!selected"
  class="starter-node-menu flow-menu"
  (click)="$event.stopPropagation()"
  #nodeMenuElement
>
  <lhpe-input
    controlName="flowName"
    placeholder="Flow name"
    [formGroup]="starterNodeForm!"
    [required]="true"
  >
  </lhpe-input>

  <div class="trigger">
    <lhpe-select
      controlName="trigger"
      placeholder="Initial Trigger"
      [formGroup]="starterNodeForm!"
      [required]="true"
      [options]="triggerOptions"
      [optionIsSelf]="true"
      displayValue="label"
    >
    </lhpe-select>
  </div>

  <div
    *ngIf="
      starterNodeForm.controls.trigger.value !== null && starterNodeForm.controls.trigger.value.location_required == true
    "
    class="trigger-location"
  >
    <lhpe-select
      controlName="triggerLocation"
      [placeholder]="locationPlaceholder"
      [formGroup]="starterNodeForm!"
      [required]="true"
      [options]="locationOptions"
      [optionIsSelf]="true"
      displayValue="name"
    >
    </lhpe-select>
  </div>

  <div
    *ngIf="
      starterNodeForm.controls.trigger.value !== null && starterNodeForm.controls.trigger.value.interval_required == true
    "
  >
    <div class="trigger-interval-cue">
      Time since {{starterNodeForm.controls.trigger.value.label}}
    </div>
    <div class="trigger-interval">
      <lhpe-input
        class="input"
        controlName="intervalDays"
        placeholder="Day(s)"
        [formGroup]="starterNodeForm!"
        [required]="true"
        type="number"
      >
      </lhpe-input>
      <lhpe-input
        class="input"
        controlName="intervalHours"
        placeholder="Hour(s)"
        [formGroup]="starterNodeForm!"
        [required]="true"
        type="number"
      >
      </lhpe-input>
      <lhpe-input
        class="input"
        controlName="intervalMinutes"
        placeholder="Minute(s)"
        [formGroup]="starterNodeForm!"
        [required]="true"
        type="number"
      >
      </lhpe-input>
    </div>
  </div>

  <div *ngIf="isAPIRequestTrigger" class="api-request-credentials">
    <div class="heading"><strong>API Request Endpoint</strong></div>
    <div class="doc-grid">
      <div class="doc-label">Method</div>
      <div class="doc-value">POST</div>

      <div class="doc-label">URL</div>
      <div class="doc-value">
        <code
          class="copyable-value"
          title="Click to copy URL"
          (click)="copyToClipboard(apiRequestURL)"
          >{{ apiRequestURL }}</code
        >
      </div>

      <div class="doc-label">Header</div>
      <div class="doc-value">
        <code
          class="copyable-value"
          title="Click to copy header"
          (click)="copyToClipboard(apiAuthHeaderValue)"
          >{{ apiAuthHeaderValue }}</code
        >
      </div>

      <div class="doc-label">Body</div>
      <div class="doc-value">
        JSON object is required and must include
        <code>account_app_user_foreign_id</code>. Additional
        fields are forwarded as <code>APIRequest</code> data for signal templates (for
        example <code>{{ '{{APIRequest.event_name}}' }}</code>).
      </div>
    </div>
  </div>

  <div class="facilities" *ngIf="starterNodeForm.controls.trigger.value !== null && starterNodeForm.controls.trigger.value.internal == false && facilities.length > 1">
    <div class="heading">Applies to customers of</div>
    <button mat-button [color]="selectedFacilities.length > 0 ? 'lightGreen' : 'warn'" (click)="selectFacilities()">{{selectedFacilities.length}} {{selectedFacilities.length === 1 ? 'Facility' : 'Facilities'}}</button>
  </div>

  <div class="dates">
    <div class="date start-date">
      <div class="text">Start</div>
      <button
        mat-button
        class="icon-btn"
        (click)="startDatePicker.openPicker()"
      >
        <svg-icon
          src="assets/svg/calendar.svg"
          [svgStyle]="{
            'width.px': '26.5',
            'height.px': '26.5'
          }"
          svgClass="grey"
        >
        </svg-icon>
      </button>
      <div class="options">
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="starterNodeForm"
          controlName="startDate"
        >
        </lhpe-datepicker>

        <lhpe-select
          class="hour"
          controlName="startDateHour"
          placeholder="hh"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="hourOptions"
          [optionIsSelf]="true"
        >
        </lhpe-select>

        <lhpe-select
          class="minute"
          controlName="startDateMinute"
          placeholder="mm"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="minuteOptions"
          [optionIsSelf]="true"
        >
        </lhpe-select>

        <lhpe-select
          class="pm"
          controlName="startDatePM"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="pmOptions"
        >
        </lhpe-select>
      </div>
    </div>
    <div class="date end-date">
      <div class="text">End</div>
      <button mat-button class="icon-btn" (click)="endDatePicker.openPicker()">
        <svg-icon
          src="assets/svg/calendar.svg"
          [svgStyle]="{
            'width.px': '26.5',
            'height.px': '26.5'
          }"
          svgClass="grey"
        >
        </svg-icon>
      </button>
      <div class="options">
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="starterNodeForm"
          controlName="endDate"
        >
        </lhpe-datepicker>

        <lhpe-select
          class="hour"
          controlName="endDateHour"
          placeholder="hh"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="hourOptions"
          [optionIsSelf]="true"
        >
        </lhpe-select>

        <lhpe-select
          class="minute"
          controlName="endDateMinute"
          placeholder="mm"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="minuteOptions"
          [optionIsSelf]="true"
        >
        </lhpe-select>

        <lhpe-select
          class="pm"
          controlName="endDatePM"
          [formGroup]="starterNodeForm!"
          [required]="true"
          [options]="pmOptions"
        >
        </lhpe-select>
      </div>
    </div>
  </div>

</div>
